module.exports = __webpack_public_path__ + "static/imp-8a64a5777bc02c5cb95b5320532d25d9.jpg";